import React from 'react';
import { useNavigate } from 'react-router-dom';

const Race = ({ race, hasPick, onPickClick }) => {
  const navigate = useNavigate();
  const raceStarted = new Date() > new Date(race.startTime);

  return (
    <div className="race-card">
      {race.canceled && (
        <div className="race-canceled-overlay">
          <span className="race-canceled-text">Race Canceled</span>
        </div>
      )}
      <h2
        onClick={() => navigate(`/races/${race._id}`)}
        className="race-name-link"
      >
        {race.name}
      </h2>
      <p className="race-location">📍 {race.circuit}</p>
      <p className="race-date">📅 {new Date(race.startTime).toLocaleDateString()}</p>
      <p className="race-time">🕐 {new Date(race.startTime).toLocaleTimeString()}</p>

      {hasPick && !raceStarted ? (
        <div className="pick-status">
          <span className="checkmark">✅</span>
          <p>Pick submitted!</p>
          <button className="pick-button" onClick={onPickClick}>
            ✏️ Edit Pick
          </button>
        </div>
      ) : hasPick ? (
        <div className="pick-status">
          <span className="checkmark">✅</span>
          <p>Pick submitted!</p>
        </div>
      ) : raceStarted ? (
        <button className="pick-button" disabled>
          🔒 Race locked
        </button>
      ) : (
        <button className="pick-button" onClick={onPickClick}>
          Pick Podium
        </button>
      )}
    </div>
  );
};

export default Race;
